import type { Router } from '@remix-run/router';
import { ReactNode } from 'react';
import IcomxChatProvider from './IcomxChatProvider';
import useIcomxSession from './useIcomxSession';

interface AuthenticatedIcomxChatProviderProps {
  children: ReactNode;
  router: Router;
}

export function canRenderIcomx(status: { isLoggedIn?: boolean; hasCompletedLoginSetup?: boolean } | null | undefined) {
  return !!status?.isLoggedIn && !!status?.hasCompletedLoginSetup;
}

export default function AuthenticatedIcomxChatProvider({ children, router }: AuthenticatedIcomxChatProviderProps) {
  const sessionKey = useIcomxSession(router);

  // Keep the provider/page tree stable; only its iframe runtime is session-scoped.
  return <IcomxChatProvider sessionKey={sessionKey}>{children}</IcomxChatProvider>;
}
